export default __webpack_public_path__ + "static/media/login.71e258ee.jpg";